import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";
import Button from "../../../Custom/Button/Button";
import deleteImg from "../../../../picture/delete.png";

const DEFAULT_UPUTSTVO = `Пре почетка попуњавања теста потребно је пажљиво прочитати питање и при давању одговора заокружити само један од понуђених одговора. Запослени који је одговорио на 75% питања и више сматра се да је успешно положио тест. У супротном оспособљавање запосленог се мора поновити.

Запослени који је положио сматра се да је теоријски и практично разумео и прихватио теме по Програму оспособљавања и сматра се да је оспособљен за безбедан и здрав рад на радном месту на које је распоређен. Својим потписом потврђује да ће примењивати добијена упутства за рад и обавезује се да ће стечена знања примењивати на радном месту у циљу безбедности и здравља на раду и да је свестан својих права, обавеза и одговорности сходно законској регулативи.`;

const styles = {
  btn: { padding: "5px 20px", fontWeight: "bold" },
  input: { width: "100%", padding: "7px 10px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "3px" },
  label: { fontWeight: "bold", fontSize: "13px", marginBottom: "4px", display: "block" },
  card: { border: "1px solid #ccc", borderRadius: "4px", padding: "10px 14px", marginBottom: "6px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "10px", background: "#fff", cursor: "pointer" },
  cardSelected: { border: "2px solid #2196F3", borderRadius: "4px", padding: "10px 14px", marginBottom: "6px", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "10px", background: "#e3f2fd", cursor: "pointer" },
  sectionHeader: { fontWeight: "bold", fontSize: "13px", color: "#555", marginTop: "14px", marginBottom: "6px", textTransform: "uppercase", borderBottom: "1px solid #ddd", paddingBottom: "4px" },
};

const emptyCustom = { pitanje: "", odgovor_a: "", odgovor_b: "", odgovor_c: "", sekcija: "ОПШТИ ДЕО" };
const SEKCIJE = ["ОПШТИ ДЕО", "ПОСЕБНИ ДЕО"];

function TestBZR({ zaposlen, handleZatvori, onSaved }) {
  const { baseUrl, selectedMainEntity } = useGlobalContext();
  const company_id = selectedMainEntity?.company_id;

  const [katalog, setKatalog] = useState([]);
  const [custom, setCustom] = useState([]);
  const [odabrana, setOdabrana] = useState({ "ОПШТИ ДЕО": [], "ПОСЕБНИ ДЕО": [] });
  const [tab, setTab] = useState("KATALOG");
  const [aktivnaSekcija, setAktivnaSekcija] = useState("ОПШТИ ДЕО");
  const [novoP, setNovoP] = useState(emptyCustom);
  const [loading, setLoading] = useState(false);
  const [datum, setDatum] = useState(new Date().toISOString().split("T")[0]);
  const [uputstvo, setUputstvo] = useState(DEFAULT_UPUTSTVO);
  const [editUputstvo, setEditUputstvo] = useState(false);

  useEffect(() => {
    if (!company_id) return;
    axios.post(`${baseUrl}/bzr/get_pitanja.php`, { company_id })
      .then(({ data }) => {
        if (data.status === 200) { setKatalog(data.katalog || []); setCustom(data.custom || []); }
      });
  }, [company_id]);

  const toggleOdabir = (pit, izvor) => {
    const sek = pit.sekcija || "ОПШТИ ДЕО";
    const key = `${izvor}_${pit.id}`;
    setOdabrana(prev => {
      const lista = prev[sek] || [];
      const vec = lista.find(o => o._key === key);
      return { ...prev, [sek]: vec ? lista.filter(o => o._key !== key) : [...lista, { ...pit, _key: key, _izvor: izvor }] };
    });
  };

  const isOdabrano = (pit, izvor) => {
    const sek = pit.sekcija || "ОПШТИ ДЕО";
    return (odabrana[sek] || []).some(o => o._key === `${izvor}_${pit.id}`);
  };

  const ukloniIzOdabranih = (pit) => {
    const sek = pit.sekcija || "ОПШТИ ДЕО";
    setOdabrana(prev => ({ ...prev, [sek]: (prev[sek] || []).filter(o => o._key !== pit._key) }));
  };

  const ukupnoOdabrano = Object.values(odabrana).flat().length;

  const handleSacuvajNovo = async () => {
    if (!novoP.pitanje || !novoP.odgovor_a || !novoP.odgovor_b) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${baseUrl}/bzr/save_custom_pitanje.php`, {
        company_id, ...novoP, odgovor_c: novoP.odgovor_c || null,
      });
      if (data.status === 200) {
        setCustom(prev => [...prev, { ...novoP, id: data.id }]);
        setNovoP(emptyCustom);
        setTab("CUSTOM");
      }
    } finally { setLoading(false); }
  };

  const handleObrisiCustom = async (id, sekcija) => {
    if (!window.confirm("Obrisati ovo pitanje?")) return;
    await axios.post(`${baseUrl}/bzr/delete_custom_pitanje.php`, { id, company_id });
    setCustom(prev => prev.filter(p => p.id !== id));
    const sek = sekcija || "ОПШТИ ДЕО";
    setOdabrana(prev => ({ ...prev, [sek]: (prev[sek] || []).filter(o => o._key !== `custom_${id}`) }));
  };

  const buildHtml = () => {
    const ime = `${zaposlen.prezime} ${zaposlen.ime}`;
    const radnoMesto = zaposlen.radnoMesto || "";
    const opsti = odabrana["ОПШТИ ДЕО"] || [];
    const posebni = odabrana["ПОСЕБНИ ДЕО"] || [];

    // Format datum DD.MM.YYYY
    const [y, m, d] = datum.split("-");
    const datumPrikaz = `${d}.${m}.${y}.`;

    const renderPitanja = (lista, offset) => lista.map((pit, i) => {
      const slova = ["а", "б", "в"];
      const odg = [pit.odgovor_a, pit.odgovor_b, pit.odgovor_c].filter(Boolean);
      return `
        <p class="pitanje">${offset + i + 1}. ${pit.pitanje}</p>
        ${odg.map((o, j) => `<p class="odgovor">${slova[j]}) ${o}</p>`).join("")}
      `;
    }).join("");

    const uputstvoHtml = uputstvo.split("\n\n")
      .map(par => `<p class="uputstvo-par">${par.replace(/\n/g, " ")}</p>`).join("");

    return `<!DOCTYPE html>
<html lang="sr">
<head>
<meta charset="UTF-8"/>
<title>Тест БЗР — ${ime}</title>
<style>
  @page { size: A4 portrait; margin: 25mm 20mm 20mm 25mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: "Times New Roman", Times, serif;
    font-size: 11pt;
    color: #000;
    background: #fff;
    line-height: 1.3;
  }

  /* Naslov */
  .naslov {
    text-align: center;
    font-weight: bold;
    font-size: 14pt;
    letter-spacing: 6px;
    margin-bottom: 2pt;
  }
  .podnaslov {
    text-align: center;
    font-size: 11pt;
    margin-bottom: 14pt;
  }

  /* Header tabela — 3 reda x 2 kolone */
  table.header {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 12pt;
  }
  table.header td {
    border: 1px solid #000;
    padding: 4pt 7pt;
    font-size: 11pt;
    vertical-align: middle;
  }
  table.header td.label {
    width: 35%;
    font-weight: bold;
    white-space: nowrap;
  }
  table.header td.value {
    width: 65%;
  }

  /* Uputstvo */
  .uputstvo-naslov {
    font-weight: bold;
    font-size: 8pt;
    text-decoration: underline;
    margin: 10pt 0 4pt 0;
  }
  .uputstvo-par {
    font-size: 8pt;
    text-align: justify;
    margin-bottom: 3pt;
  }

  /* Rezultat / potpis obuke */
  .rezultat-blok {
    margin-top: 10pt;
    font-size: 12pt;
  }
  .rezultat-blok p {
    margin-bottom: 3pt;
  }
  .polozio-red {
    display: flex;
    gap: 60pt;
    margin: 2pt 0 6pt 10pt;
    font-size: 12pt;
  }
  .obuka-red {
    font-size: 12pt;
    margin-bottom: 2pt;
  }
  .obuka-linija {
    display: inline-block;
    border-bottom: 1px solid #000;
    width: 150pt;
    margin-left: 4pt;
    vertical-align: bottom;
  }

  /* Separator */
  .hr { border: none; border-top: 1px solid #000; margin: 10pt 0; }

  /* Sekcija naslov */
  .sekcija-naslov {
    font-weight: bold;
    font-size: 11pt;
    margin: 14pt 0 6pt 0;
  }

  /* Pitanja */
  .pitanje {
    font-weight: bold;
    font-size: 11pt;
    margin: 8pt 0 2pt 0;
  }
  .odgovor {
    font-size: 11pt;
    margin: 1pt 0 1pt 18pt;
  }

  /* Potpis zaposlenog */
  .potpis-wrap {
    margin-top: 30pt;
    text-align: right;
    font-size: 11pt;
  }
  .potpis-linija {
    display: block;
    border-bottom: 1px solid #000;
    width: 160pt;
    margin: 14pt 0 0 auto;
  }

  /* Print dugme */
  .print-btn {
    position: fixed;
    bottom: 24px;
    right: 24px;
    padding: 10px 28px;
    background: #1565C0;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0,0,0,0.25);
    z-index: 999;
  }
  @media print { .print-btn { display: none; } }
</style>
</head>
<body>

  <p class="naslov">Т Е С Т</p>
  <p class="podnaslov">ЗА ПРОВЕРУ ТЕОРИЈСКОГ ЗНАЊА ИЗ ОБЛАСТИ БЕЗБЕДНОСТИ И ЗДРАВЉА НА РАДУ</p>

  <table class="header">
    <tr>
      <td class="label">ПРЕЗИМЕ И ИМЕ:</td>
      <td class="value">${ime}</td>
    </tr>
    <tr>
      <td class="label">НАЗИВ РАДНОГ МЕСТА:</td>
      <td class="value">${radnoMesto}</td>
    </tr>
    <tr>
      <td class="label">ДАТУМ ТЕСТИРАЊА:</td>
      <td class="value">${datumPrikaz}</td>
    </tr>
  </table>

  <p class="uputstvo-naslov">УПУТСТВО – Обавезно прочитати пре попуњавања теста и потписивања</p>
  ${uputstvoHtml}

  <div class="rezultat-blok">
    <p>Резултат тестирања:</p>
    <div class="polozio-red">
      <span>положио</span>
      <span>није положио</span>
    </div>
    <p class="obuka-red">Обуку извршио: <span class="obuka-linija"></span></p>
  </div>

  <div class="hr"></div>

  ${opsti.length > 0 ? `<p class="sekcija-naslov">ТЕСТ – ОПШТИ ДЕО</p>${renderPitanja(opsti, 0)}` : ""}
  ${posebni.length > 0 ? `<p class="sekcija-naslov">ТЕСТ – ПОСЕБНИ ДЕО</p>${renderPitanja(posebni, opsti.length)}` : ""}

  <div class="potpis-wrap">
    Потпис запосленог
    <span class="potpis-linija"></span>
  </div>

  <button class="print-btn" onclick="window.print()">🖨 Штампај</button>
</body>
</html>`;
  };

  const handleGeneriši = async () => {
    if (ukupnoOdabrano === 0) return;
    setLoading(true);

    const html = buildHtml();
    const ime = `${zaposlen.prezime} ${zaposlen.ime}`;
    const blob = new Blob([html], { type: "text/html;charset=utf-8" });
    const file = new File([blob], `TestBZR_${ime.replace(/\s+/g, "_")}_${datum}.html`, { type: "text/html" });
    const datumIsteka = new Date(datum);
    datumIsteka.setFullYear(datumIsteka.getFullYear() + 2);

    const formData = new FormData();
    formData.append("employee_id", zaposlen.id);
    formData.append("naziv", "TEST BZR");
    formData.append("datum_isteka", datumIsteka.toISOString().split("T")[0]);
    formData.append("is_scan", "0");
    formData.append("file", file);

    const doSave = async (fd) => {
      const { data } = await axios.post(`${baseUrl}/zaposleni/create_document.php`, fd);
      return data;
    };

    try {
      let res = await doSave(formData);
      if (res.needs_confirm) {
        if (!window.confirm("Već postoji aktivan TEST BZR. Arhivirati stari i sačuvati novi?")) { setLoading(false); return; }
        formData.append("archive_old_id", res.old_id);
        res = await doSave(formData);
      }
      if (res.status === 200 || res.status === 201) {
        const pw = window.open("", "_blank");
        pw.document.write(html);
        pw.document.close();
        onSaved && onSaved();
        handleZatvori();
      }
    } catch (e) {
      console.error(e);
      alert("Greška pri čuvanju.");
    } finally { setLoading(false); }
  };

  const renderPitanjeCard = (pit, izvor) => {
    const odabrano = isOdabrano(pit, izvor);
    return (
      <div key={`${izvor}_${pit.id}`} style={odabrano ? styles.cardSelected : styles.card}
        onClick={() => toggleOdabir(pit, izvor)}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: "bold", fontSize: "13px", marginBottom: "4px" }}>{pit.pitanje}</div>
          <div style={{ fontSize: "12px", color: "#555" }}>
            а) {pit.odgovor_a} &nbsp;|&nbsp; б) {pit.odgovor_b}
            {pit.odgovor_c && <> &nbsp;|&nbsp; в) {pit.odgovor_c}</>}
          </div>
        </div>
        {izvor === "custom" && (
          <div onClick={e => { e.stopPropagation(); handleObrisiCustom(pit.id, pit.sekcija); }}
            style={{ marginLeft: "8px", flexShrink: 0 }}>
            <img src={deleteImg} style={{ width: "20px", opacity: 0.6 }} />
          </div>
        )}
      </div>
    );
  };

  const tabStyle = (t) => ({
    padding: "6px 18px", fontWeight: "bold", cursor: "pointer",
    borderBottom: tab === t ? "3px solid #2196F3" : "3px solid transparent",
    color: tab === t ? "#2196F3" : "#555", fontSize: "13px",
  });

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ paddingBottom: "8px", borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>
          Kreiranje Test BZR — {zaposlen.prezime} {zaposlen.ime}
        </div>
        <div style={{ fontSize: "13px", color: "#777" }}>{zaposlen.radnoMesto}</div>
      </div>

      {/* Datum + brojač */}
      <div style={{ display: "flex", alignItems: "center", gap: "24px", marginBottom: "10px" }}>
        <div>
          <label style={styles.label}>Datum testa</label>
          <input type="date" value={datum} onChange={e => setDatum(e.target.value)}
            style={{ ...styles.input, width: "180px" }} />
        </div>
        <div style={{ fontSize: "14px", marginTop: "18px" }}>
          Odabrano: <strong>{ukupnoOdabrano}</strong> pitanja
          {SEKCIJE.map(s => (odabrana[s] || []).length > 0 && (
            <span key={s} style={{ marginLeft: "12px", fontSize: "12px", color: "#555" }}>
              {s === "ОПШТИ ДЕО" ? "Opšti" : "Posebni"}: <strong>{(odabrana[s] || []).length}</strong>
            </span>
          ))}
        </div>
      </div>

      {/* Uputstvo */}
      <div style={{ marginBottom: "10px", border: "1px solid #ddd", borderRadius: "4px", padding: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
          <span style={{ fontWeight: "bold", fontSize: "13px" }}>Уputstvo</span>
          <div onClick={() => setEditUputstvo(!editUputstvo)}>
            <Button activation={true} style={{ ...styles.btn, padding: "3px 14px", fontSize: "12px" }}>
              {editUputstvo ? "Zatvori" : "Izmeni"}
            </Button>
          </div>
        </div>
        {editUputstvo ? (
          <textarea value={uputstvo} onChange={e => setUputstvo(e.target.value)}
            rows={5} style={{ ...styles.input, resize: "vertical", fontSize: "12px" }} />
        ) : (
          <div style={{ fontSize: "12px", color: "#555", whiteSpace: "pre-line", maxHeight: "50px", overflow: "hidden", WebkitMaskImage: "linear-gradient(to bottom, black 40%, transparent)" }}>
            {uputstvo}
          </div>
        )}
      </div>

      {/* Tabovi */}
      <div style={{ display: "flex", borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
        <div style={tabStyle("KATALOG")} onClick={() => setTab("KATALOG")}>Katalog pitanja</div>
        <div style={tabStyle("CUSTOM")} onClick={() => setTab("CUSTOM")}>Pitanja firme ({custom.length})</div>
        <div style={tabStyle("NOVO")} onClick={() => setTab("NOVO")}>+ Novo pitanje</div>
        {ukupnoOdabrano > 0 && (
          <div style={tabStyle("PREGLED")} onClick={() => setTab("PREGLED")}>
            Pregled ({ukupnoOdabrano})
          </div>
        )}
      </div>

      {/* Filter sekcije */}
      {(tab === "KATALOG" || tab === "CUSTOM") && (
        <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
          {SEKCIJE.map(s => (
            <div key={s} onClick={() => setAktivnaSekcija(s)}
              style={{ padding: "4px 14px", borderRadius: "20px", cursor: "pointer", fontSize: "12px", fontWeight: "bold", background: aktivnaSekcija === s ? "#333" : "#eee", color: aktivnaSekcija === s ? "#fff" : "#555" }}>
              {s}
            </div>
          ))}
        </div>
      )}

      {/* Sadržaj */}
      <div style={{ flex: 1, overflowY: "auto", paddingRight: "4px" }}>

        {tab === "KATALOG" && katalog
          .filter(p => (p.sekcija || "ОПШТИ ДЕО") === aktivnaSekcija)
          .map(p => renderPitanjeCard(p, "katalog"))}

        {tab === "CUSTOM" && (
          custom.filter(p => (p.sekcija || "ОПШТИ ДЕО") === aktivnaSekcija).length === 0
            ? <div style={{ color: "#aaa", padding: "20px", textAlign: "center" }}>Nema pitanja za ovu sekciju.</div>
            : custom.filter(p => (p.sekcija || "ОПШТИ ДЕО") === aktivnaSekcija).map(p => renderPitanjeCard(p, "custom"))
        )}

        {tab === "NOVO" && (
          <div style={{ maxWidth: "700px", display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
              <label style={styles.label}>Sekcija *</label>
              <select value={novoP.sekcija} onChange={e => setNovoP(p => ({ ...p, sekcija: e.target.value }))}
                style={{ ...styles.input, width: "280px" }}>
                {SEKCIJE.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label style={styles.label}>Pitanje *</label>
              <textarea value={novoP.pitanje} onChange={e => setNovoP(p => ({ ...p, pitanje: e.target.value }))}
                rows={3} style={{ ...styles.input, resize: "vertical" }} />
            </div>
            <div>
              <label style={styles.label}>Odgovor а) *</label>
              <input value={novoP.odgovor_a} onChange={e => setNovoP(p => ({ ...p, odgovor_a: e.target.value }))} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>Odgovor б) *</label>
              <input value={novoP.odgovor_b} onChange={e => setNovoP(p => ({ ...p, odgovor_b: e.target.value }))} style={styles.input} />
            </div>
            <div>
              <label style={styles.label}>Odgovor в) (opciono)</label>
              <input value={novoP.odgovor_c} onChange={e => setNovoP(p => ({ ...p, odgovor_c: e.target.value }))} style={styles.input} />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={() => setTab("CUSTOM")}>
                <Button activation={true} style={styles.btn}>Odustani</Button>
              </div>
              <div onClick={!loading ? handleSacuvajNovo : undefined}
                style={{ opacity: (!novoP.pitanje || !novoP.odgovor_a || !novoP.odgovor_b) ? 0.5 : 1 }}>
                <Button activation={true} style={styles.btn}>{loading ? "..." : "Sačuvaj pitanje"}</Button>
              </div>
            </div>
          </div>
        )}

        {tab === "PREGLED" && (
          <div>
            {SEKCIJE.map(sek => (odabrana[sek] || []).length > 0 && (
              <div key={sek}>
                <div style={styles.sectionHeader}>{sek}</div>
                {(odabrana[sek] || []).map((pit, i) => (
                  <div key={pit._key} style={{ ...styles.card, cursor: "default" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "bold", fontSize: "13px" }}>{i + 1}. {pit.pitanje}</div>
                      <div style={{ fontSize: "12px", color: "#555", marginTop: "4px" }}>
                        а) {pit.odgovor_a} &nbsp;|&nbsp; б) {pit.odgovor_b}
                        {pit.odgovor_c && <> &nbsp;|&nbsp; в) {pit.odgovor_c}</>}
                      </div>
                    </div>
                    <div onClick={() => ukloniIzOdabranih(pit)}
                      style={{ cursor: "pointer", color: "#e00", fontSize: "20px", lineHeight: 1, marginLeft: "8px" }}>×</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Dugmad */}
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "14px", paddingTop: "10px", borderTop: "1px solid #ddd" }}>
        <div onClick={handleZatvori}>
          <Button activation={true} style={styles.btn}>Odustani</Button>
        </div>
        <div onClick={!loading && ukupnoOdabrano > 0 ? handleGeneriši : undefined}
          style={{ opacity: ukupnoOdabrano === 0 || loading ? 0.5 : 1 }}>
          <Button activation={true} style={{ ...styles.btn, backgroundColor: "#1565C0", color: "white" }}>
            {loading ? "Generišem..." : `Generiši test (${ukupnoOdabrano} pitanja)`}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default TestBZR;